import React from 'react';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Component, Atom} from '@packages/systems/wfdl';
import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
} from '@packages/systems/wfdl-ast';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';

// eslint-disable-next-line webflow/module-top-level-imports
import {withLlmRender} from '@packages/utilities/llm-wfdl-renderer/withLlmRender';
import {useRuntimeEnvironment} from '@packages/systems/render';

const MapWidget = Atom.createRender(
  withLlmRender(({attributes, classes, generateAttributes, context}) => {
    const runtimeEnvironment = useRuntimeEnvironment();
    const mapClasses = classes
      .push('w-widget')
      .push('w-widget-map')
      .update((cls) => {
        return runtimeEnvironment === WebflowEnvironments.DESIGNER &&
          !context.get('googleMapsApiKey')
          ? cls.push('wf-missing-api-key')
          : cls;
      });

    const updatedAttributes = attributes.update(
      'aria-label',
      (original) => attributes.get('title') || original
    );

    return <div {...generateAttributes(updatedAttributes, mapClasses)} />;
  })
);

const config = Atom.create({
  displayName: 'Map',
  constraints: {
    ancestors: [{is: 'DynamoItem', rule: 'Forbid'}],
  },
  showEmpty: false,
  icon: {
    value: qualify(Plugins.name('Widget'), iconName('Map')),
    type: 'Component',
  },
  render: MapWidget,
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Widget'), typeName('MapWidget'))
  ),
});

export const mapWidgetFactory = EElement({
  id: 'Map Widget',
  type: qualify(Plugins.name('Widget'), Component.name('MapWidget')),
  data: ERecord({
    widget: ERecord({
      type: EText('map'),
      address: EText(''),
    }),
    search: ERecord({
      exclude: EBoolean(true),
    }),
    attr: ERecord({
      'data-enable-touch': EBoolean(true),
      'data-enable-scroll': EBoolean(true),
      'data-widget-style': EEnum('roadmap'),
      'data-widget-zoom': ENumber(12),
      'data-widget-latlng': EText(''),
      'data-widget-tooltip': EText(''),
      title: EText(''),
      role: EText('region'),
    }),
  }),
});

export default config;
